export default function getQueryParams(qs) {
  let vars = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
    vars[key] = value
  })
  return vars
}



// WEBPACK FOOTER //
// ./src/utils/queryParams.js